export type { TableProps } from "./Table.interface";
export { Table } from "./Table";